import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import MultiSelectTree from "../../../components/multi-select-tree/multi-select-tree";
import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { dataBrowserListSetFiltersAction } from "../redux/lists.actions";

const selector = createSelector(
    (state: IRootState) => state.categories,
    (state: IRootState) => state.dataBrowserList.filters,
    (categories, filters) => ({
        options:
            categories.data?.map((category) => ({
                id: category.name,
                name: category.name,
                children: category.children.map((child) => ({
                    id: child,
                    name: child,
                })),
            })) ?? [],
        isLoading: categories.isLoading,
        filters,
        selectedItems: filters?.category?.map((data) => ({
            id: data,
            name: data,
        })),
    }),
);

const CategoryFilter = () => {
    const { options, isLoading, selectedItems, filters } =
        useSelector(selector);
    const dispatch = useDispatch();

    const onChange = (selectedCategories: Array<IListItem>) =>
        dispatch(
            dataBrowserListSetFiltersAction({
                ...filters,
                category: selectedCategories.map(({ id }) => id),
            }),
        );

    return !isLoading ? (
        <MultiSelectTree
            onChange={onChange}
            selectedItems={selectedItems ?? []}
            items={options}
            multiline={true}
            clearAllOption={true}
        />
    ) : (
        <Skeleton />
    );
};

export default CategoryFilter;
